<!-- Desktop Sidebar -->
@if (visible) {
<!-- Sidebar -->
<aside class="w-64 h-full border-r flex-shrink-0">
  <nav class="p-4 h-full overflow-y-auto flex flex-col">
    <div class="flex-1">
      <p-divider align="left">
        <span class="text-label-md">{{ 'home.navigation' | translate }}</span>
      </p-divider>

      <!-- PanelMenu for navigation -->
      <p-panelmenu [model]="menuItems" styleClass="w-full"></p-panelmenu>
    </div>

    <!-- Logout button at the bottom -->
    <div class="mt-auto pt-4">
      <p-divider></p-divider>
      <a
        (click)="logout()"
        pButton
        [outlined]="true"
        icon="pi pi-sign-out"
        [label]="'common.logout' | translate"
        class="p-button-fluid !justify-start p-button-danger"
      >
      </a>
    </div>
  </nav>
</aside>
}
